import { DetailPage } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function VerreFrequenceFields({ item, set, tab }) {
    const t = useTranslations()
    return <>
        <TextInput label={t("Nom")} value={item.nom} onChange={set('nom')} required />
    </>
}

export function VerreFrequencesList(props) {
    const t = useTranslations()
    return <ListPage model="verreFrequence" title={t("Fréquence de verre")} columns={{
        [t('Nom')]: 'nom',
    }} {...props} />
}

export function VerreFrequenceDetail(props) {
    const t = useTranslations()
    return <DetailPage model="verreFrequence" title={t("Fréquence de verre")} Fields={VerreFrequenceFields} {...props} />
}
